import { css } from '@emotion/react'
import { colorTokens, spacingTokens } from '../../../styles/tokens'

/**
 * Emotion `css` objects for the full-bleed login shell.
 *
 * The codebase bans `sx`/`style` props outside `src/components/layout` and
 * `src/styles` (see `linter-plugins/no-inline-styles.grit`); the Emotion `css`
 * prop is the sanctioned escape hatch for layout-heavy sections (see
 * `components/home/Hero.tsx`).
 */
export const styles = {
  shell: css`
    position: absolute;
    inset: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    display: flex;
    background: ${colorTokens.white};
    outline: none;
    overflow: hidden;
  `,
  formColumn: css`
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: ${spacingTokens.pageMargin}px;
    overflow-y: auto;

    @media (min-width: 768px) {
      flex: 1 1 50%;
      padding: ${spacingTokens.sectionGap}px;
    }
  `,
  brand: css`
    display: flex;
    align-items: center;
    gap: ${spacingTokens.cardGap}px;
    flex-wrap: wrap;
  `,
  // Shared heading treatment (Cabinet Grotesk, weight 900) matching the home
  // hero. `!important` guarantees it wins over MUI's Typography variant class
  // regardless of style-injection order.
  headingFont: css`
    font-family:
      var(--font-cabinet-grotesk), 'system-ui', Arial, sans-serif !important;
    font-weight: 900 !important;
  `,
  logo: css`
    width: 150px;
    height: auto;
  `,
  logoAiClaims: css`
    width: 150px;
    height: auto;
  `,
  logoDivider: css`
    display: inline-block;
    width: 1px;
    height: 22px;
    background: ${colorTokens.slate300};
    flex-shrink: 0;
  `,
  closeButton: css`
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 2;
    color: ${colorTokens.slate700};

    @media (min-width: 768px) {
      color: ${colorTokens.white};
    }
  `,
  formBody: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    padding: ${spacingTokens.sectionGap}px 0;
  `,
  showcaseColumn: css`
    display: none;

    @media (min-width: 768px) {
      display: flex;
      flex: 1 1 50%;
      position: relative;
      align-items: center;
      justify-content: center;
      /* No horizontal padding: the carousel viewport spans the full panel width
         (each slide carries its own padding) so content isn't clipped mid-panel
         during auto-scroll. */
      padding: 0;
      background-color: ${colorTokens.green100};
      overflow: hidden;

      /* Subtle branded depth behind the floating card. */
      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background:
          radial-gradient(
            circle at 18% 18%,
            rgba(255, 255, 255, 0.1),
            transparent 45%
          ),
          radial-gradient(
            circle at 82% 82%,
            rgba(20, 39, 27, 0.18),
            transparent 42%
          );
      }
    }
  `,
}
